import { MFCColour, MFCColours } from "../../types";

export const filterOutMFCColour = (boardColours : MFCColour[]| MFCColours, code? : MFCColour['code'], texture? : MFCColour['texture']) => {
    if(!code || !texture) return;
    return boardColours.filter(boardColour => boardColour.code !== code || boardColour.texture !== texture);
}
